import { LoaderCircle } from 'lucide-react'

/**
 * 24px Spinner used by SignIn and AuthCallback.
 *
 * Respects `prefers-reduced-motion` automatically — the `animation` CSS
 * property is zeroed in tokens.css when the user prefers reduced motion.
 */
export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        animation: 'clearroute-spin 1s linear infinite',
        lineHeight: 0,
      }}
    >
      <LoaderCircle size={size} strokeWidth={2} />
      <style>{`
        @keyframes clearroute-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </span>
  )
}
